var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.defaultResponses.length
    ? _c("div", { staticClass: "answers" }, [
        _c("div", { attrs: { tabindex: "0", "aria-live": "assertive" } }, [
          _vm._v(_vm._s(_vm.$gettext("O encuentra respuestas")) + ":"),
        ]),
        _c("div", { staticClass: "action-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            attrs: {
              placeholder: _vm.$gettext("Buscar..."),
              name: "searchInput",
            },
            domProps: { value: _vm.search },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.search = $event.target.value
              },
            },
          }),
        ]),
        _c(
          "div",
          { staticClass: "answersList" },
          _vm._l(_vm.filteredList, function (type) {
            return _c("type-answers", { key: type.id, attrs: { type: type } })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }